import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
  GET_LOCATIONS,
  GET_SUB_LOCATIONS,
  GET_DEPARTMENT,
  GET_USERS,
  USER_ROW_DATA,
  GROUPS_LIST,
  USER_ADD,
  USER_EDIT,
  USER_DELETE,
  GROUP_ADD,
  PAGINATION_GROUPS_LIST,
} from "./actionTypes";
import {
  apiError,
  locationListSuccessful,
  sublocationListSuccessful,
  DepartmentListSuccessful,
  usersListSuccessful,
  UserRowDataSuccessful,
  groupsListSuccessful,
  getSubLocations,
  //-------------
  getUsers,
  // locationListSuccessful,
  userAddSuccessfull,
  getLocations,
  getDepartment,
  groupAddSuccessfull,
  getGroupsList,
  paginationGroupsListSuccessful,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  getParamsList,
  postEdit,
  patchEdit,
  postDelete,
  // getRowData,
  // postUpload,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getLocation() {
  try {
    const response = yield call(getList, "/masters/mini/locations/", {});
    yield put(locationListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* SubLocation() {
 
  try {
    const response = yield call(getList, "/masters/mini/sublocations/", {});
  
    yield put(sublocationListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getDepartments() {
  try {
    const response = yield call(getList, "/masters/mini/departments/", {});
    yield put(DepartmentListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getUserList({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/users/list/", params);
    yield put(usersListSuccessful(response));
  } catch (error) {
 
    yield put(apiError(error));
  }
}
function* getUserRow({ payload: { UserId } }) {
 
  try {
    const response = yield call(getList, "/users/" + UserId, {});
    
    const calls = yield [];
    if (response) {
      yield put(UserRowDataSuccessful(response));

      // response.locations.forEach((loc) => {
      // SubLocation({ payload: { id: 2 } });
      // });

      response.locations.forEach((loc) =>
        calls.push(call(getSubLocations, loc.id))
      );
      yield all(calls);
    }
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getGroupList({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/users/groups/", params);
    yield put(groupsListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getPaginationGroupList({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/users/groups/", params);
    yield put(paginationGroupsListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
//-----------------------
// function* getLocation() {
//   try {
//     const response = yield call(getList, "/masters/mini/locations/", {});
//     yield put(locationListSuccessful({ response }));
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }
//If user is login then dispatch redux action's are directly from here.
function* AddUser({ payload: { userdata, Userdata2 } }) {
  try {
    const response = yield call(postAdd, "/users/list/", userdata);

    if (response.status === 201) {
      const response2 = yield call(
        patchEdit,
        "/users/" + response.data.id,
        Userdata2
      );

      if (response2.status === 200) {
        swal("Poof! Your User Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getUsers());
      } else {
        swal("Sorry! Unable to add User. Please Try Again!", {
          icon: "error",
          timer: 1500,
        });
      }
    } else {
      swal("Sorry! Unable to add User. Please Try Again!", {
        icon: "error",
        timer: 1500,
      });
    }
    yield put(userAddSuccessfull(null));
    yield put(getLocations());
    yield pit(getSubLocations());
    yield pit(getDepartment());
  } catch (errors) {
    // yield put(apiError(errors));
    swal("Sorry! something went wrong, Please Check You inputs and try again", {
      icon: "error",
    });
  }
}
function* EditUser({ payload: { userdata, Userdata2 } }) {
  try {
    const response = yield call(postEdit, "/users/" + userdata.id, userdata);

    if (response.status === 200) {
      const response2 = yield call(
        patchEdit,
        "/users/" + userdata.id,
        Userdata2
      );

      if (response2.status === 200) {
        swal("Poof! Your User Update Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getUsers());
      } else {
        swal("Sorry! Unable to Update User. Please Try Again!", {
          icon: "error",
          timer: 1500,
        });
      }
    } else {
      swal("Sorry! Unable to Update User. Please Try Again!", {
        icon: "error",
        timer: 1500,
      });
    }
    yield put(userAddSuccessfull(null));
    yield put(getLocations());
    yield put(getSubLocations());
    yield put(getDepartment());
  } catch (errors) {
    yield put(apiError(errors));
    // swal(errors,{
    //   title: errors,
    //   icon: "error",
    // });
  }
}
function* DeleteUsers(userId) {
  try {
    const response = yield call(
      postDelete,
      "/apimasters/musers/" + userId.payload.userId + "/"
    );
    if (response.status === 204) {
      swal("Poof! Your User has been deleted!", {
        icon: "success",
      });
      yield put(getUsers());
    } else {
      swal("Sorry! Your User has been not deleted!", {
        icon: "error",
      });
    }
    // yield put(locationDeleteSuccessful(response.statusText))
  } catch (error) {
    swal(error, {
      icon: "error",
    });

    //yield put(apiError(error));
  }
}

function* AddGroup({ payload: { groupdata } }) {
  try {
    if (groupdata.id === 0) {
      const response = yield call(postAdd, "/apimasters/mgroups/", {
        name: groupdata.pName,
      });
      if (response.status === 200) {
        swal("Poof! Your User Added Successfully.!", {
          icon: "success",
        });
        yield put(getGroupsList());
      } else {
        swal("Sorry! Unable to ad User. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(groupAddSuccessfull(null));
    } else {
      const response = yield call(
        postEdit,
        "/apimasters/musers/" + groupdata.id + "/",
        { name: groupdata.username }
      );
      if (response.status === 200) {
        swal("Poof! Your User Edited Successfully.!", {
          icon: "success",
        });
        yield put(getGroupsList());
      } else {
        swal("Sorry! Unable to edit User. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(groupAddSuccessfull(null));
    }
  } catch (error) {
    swal(error, {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}
export function* watchGetLocattions() {
  yield takeEvery(GET_LOCATIONS, getLocation);
}
export function* watchGetSubLocattions() {
  yield takeEvery(GET_SUB_LOCATIONS, SubLocation);
}
export function* watchGetDepartments() {
  yield takeEvery(GET_DEPARTMENT, getDepartments);
}
export function* watchgetUsers() {
  yield takeEvery(GET_USERS, getUserList);
}
export function* watchgetRowUsers() {
  yield takeEvery(USER_ROW_DATA, getUserRow);
}
export function* watchgetGroups() {
  yield takeEvery(GROUPS_LIST, getGroupList);
}
export function* watchgetPaginationGroups() {
  yield takeEvery(PAGINATION_GROUPS_LIST, getPaginationGroupList);
}
export function* watchUserAdd() {
  yield takeEvery(USER_ADD, AddUser);
}
export function* watchUserEdit() {
  yield takeEvery(USER_EDIT, EditUser);
}
export function* watchUserDelete() {
  yield takeEvery(USER_DELETE, DeleteUsers);
}

export function* watchGroupAdd() {
  yield takeEvery(GROUP_ADD, AddGroup);
}

function* UsersSaga() {
  yield all([
    fork(watchGetLocattions),
    fork(watchGetSubLocattions),
    fork(watchGetDepartments),
    fork(watchgetUsers),
    fork(watchgetRowUsers),
    fork(watchgetGroups),
    // fork(watchGetLocattions),
    fork(watchUserAdd),
    fork(watchUserEdit),
    fork(watchUserDelete),
    fork(watchGroupAdd),
    fork(watchgetPaginationGroups)
  ]);
}

export default UsersSaga;
